import middlewares from '@/core/services/routeMiddlewares.service';

import RouteNames from '@/constants/route-names';

import ClickbuyLayout from '@/clickbuy/clickbuy.layout.vue';

import PurchaseView from '@/clickbuy/purchase/views/purchase.view.vue';
import ConvocationList from '@/clickbuy/convocation/views/convocation-list/index.vue';
import ParticipantList from '@/clickbuy/convocation/views/participant-list/index.vue';
import ProductCategoryView from '@/clickbuy/purchase/views/product-category.view.vue';
import SalesView from '@/clickbuy/purchase/views/sales-view/index.vue';

const ClickBuyRouter = {
    path: '/cb/',
    component: ClickbuyLayout,
    name: 'cb',
    beforeEnter: middlewares.ifAuthenticated,
    redirect: { name: RouteNames.cbConvocationList },
    children: [
        {
            path: 'convocation',
            name: RouteNames.cbConvocationList,
            component: ConvocationList,
        }, {
            path: 'convocation/:id',
            name: RouteNames.cbPariticipantList,
            props: true,
            component: ParticipantList,
        }, {
            path: 'convocation/:convocationId/participant/:participantId/purchase',
            name: RouteNames.cbPurchaseParticipant,
            props: true,
            component: PurchaseView,
            helpText: 'Url para asistentes que no tienen compra o para añadir una compra junto con un nuevo asistente',
        }, {
            path: 'purchase/:purchaseId',
            name: RouteNames.cbPurchase,
            props: true,
            component: PurchaseView,
            helpText: 'Url para asistentes que tienen compra (te llevará al segundo formulario o a la pantalla de descarga)',
        }, {
            path: 'companion/:companionId',
            name: RouteNames.cbPurchaseCompanion,
            props: true,
            component: PurchaseView,
            helpText: 'Url para acompañantes de una compra (te llevará al segundo formulario o a la pantalla de descarga)',
        }, {
            path: 'convocation/:id/product-category',
            name: RouteNames.cbProductCategory,
            props: true,
            component: ProductCategoryView,
        }, {
            path: 'convocation/:convocationId/product-category/:productTypeId/sales',
            name: RouteNames.cbSales,
            props: true,
            component: SalesView,
        },
    ],
};

export default [
    ClickBuyRouter,
];
